import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getBorderRadiusOptions,
  getImageOpacityOptions,
  getObjectFitOptions,
  getObjectPositionOptions,
} from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "img",
  props: {
    image: {
      prop: "other",
      type: "circle-image-upload",
      value: {
        signed_id: null,
      },
    },
    alt: {
      prop: "other",
      type: "string",
      value: null,
    },
    href: {
      prop: "other",
      type: "url",
      value: "",
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        objectFit: getObjectFitOptions({
          defaultValue: defaultStyles.objectFit,
        }),
        objectPosition: getObjectPositionOptions({
          defaultValue: defaultStyles.objectPosition,
        }),
        opacity: getImageOpacityOptions({
          defaultValue: defaultStyles.opacity,
        }),
        borderRadius: getBorderRadiusOptions({
          defaultValue: defaultStyles.borderRadius,
        }),
        sizing: getSizingOptions({
          defaultValue: defaultStyles.sizing,
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
